<div
  class="flash-messages notification"
  *ngIf="flashMessage"
  [ngClass]="flashMessage.className"
>
  <p>{{ flashMessage.message }}</p>
</div>
